<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <Table border :columns="columns" :data="applies">
          <template #title="{ row }">
            <strong>{{ row.title }}</strong>
          </template>
          <template #action="{ row }">
            <Button type="success" size="small" style="margin-right: 5px" @click="gotoReply(row)">回复</Button>
            <Button type="error" size="small" @click="applyCheck(-1, row.id)">驳回</Button>
          </template>
          </Table>

          <div id="pager"><Page :total="num" @on-change="pageChange" show-total /></div>
      </Content>
    </Layout>
    </Layout>
  </Layout>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'
import global from '../../utils/global'
import axios from 'axios'

export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread,
},
  data () {
    return {
      user: null,
      
      page: 1,
      num: 0,
      applies: [],
      columns: [
        {
          title: '标题',
          slot: 'title',
          minWidth: 120
        },
        {
          title: '联系方式',
          key: 'mobile',
          width: 130
        },
        {
          title: '真实姓名',
          key: 'realName',
          width: 100
        },
        {
          title: '状态',
          key: 'statusTxt',
          width: 80
        },
        {
          title: '申请时间',
          key: 'createTime',
          width: 200
        },
        {
          title: '操作',
          slot: 'action',
          width: 140,
          align: 'center'
        }
      ],
    }
  },

  mounted() {
    this.initUser()
    this.initMine()
  },
  methods: {
    //初始化用户信息
    initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
      },

    initMine () {
      let vm = this
      //let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/complaint/v1.0/apply/mine',
        headers: {
          token: this.user.token
        },
        data: {
          //userId: '1',
          page: vm.page
        }
      }).then(function (response) {
        console.log(response)
        let success = response.data.success
        if(success) {
          if(response.data.data.list!=null) {
            vm.applies = response.data.data.list
          } else {
            vm.applies = []
          }
          vm.num = response.data.data.num
        }
      });
    },

    //驳回
    applyCheck(status, id) {
      let txt = '';
      if(status==1) {
        txt = '您的投诉已被受理';
      } else if(status==-1) {
        txt = '您的投诉已被驳回';
      }
      let vm = this
      //let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/complaint/v1.0/reply/save',
        data: {
          applyId: id,
          remark: txt,
          status: status
        },
        headers: {
          token: vm.user.token
        }
      }).then(function (response) {
        console.log(response)
        let success = response.data.success
        if(success) {
          vm.$Message.success('提交成功');
        } else {
          vm.$Message.console.error(response.data.message);
        }
      });
    },
    //查看
    gotoReply(item) {
      this.$router.push({path: '/admin/complaint/apply/reply', query: {id: item.id}});
    }
  }
}
</script>
